<!-- GeneralInformation.vue -->
<template>
    <div class="general-info">
      <h1 class="section-title">General Information</h1>
      <form @submit.prevent="handleSubmit" class="form-container">
        <StyledInput
          id="displayName"
          label="Name"
          v-model="localUserInfo.displayName"
        />
        <StyledInput
          id="addressLine1"
          label="Address Line 1"
          v-model="localUserInfo.address.line1"
        />
        <StyledInput
          id="addressLine2"
          label="Address Line 2"
          v-model="localUserInfo.address.line2"
        />
        <div class="city-state-zip">
          <StyledInput
            id="city"
            label="City"
            v-model="localUserInfo.address.city"
          />
          <StyledInput
            id="state"
            label="State"
            v-model="localUserInfo.address.state"
          />
          <StyledInput
            id="zip"
            label="ZIP Code"
            v-model="localUserInfo.address.zip"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
          />
        </div>
  
        <div class="actions">
          <button 
            type="submit" 
            class="save-button"
            :disabled="saving"
          >
            {{ saving ? 'Saving...' : 'Save Changes' }}
          </button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import StyledInput from './StyledInput.vue';
  
  export default {
    name: 'GeneralInformation',
    components: {
      StyledInput
    },
    props: {
      userInfo: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      },
      saving: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        localUserInfo: {
          displayName: '',
          address: {
            line1: '',
            line2: '',
            city: '',
            state: '',
            zip: ''
          }
        }
      };
    },
    watch: {
      userInfo: {
        handler(newValue) {
          this.localUserInfo = JSON.parse(JSON.stringify(newValue));
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      handleSubmit() {
        // Normalize the city input
        const cityInput = this.localUserInfo.address.city.trim();
        if (cityInput) {
          this.localUserInfo.address.city = cityInput.charAt(0).toUpperCase() + cityInput.slice(1).toLowerCase();
        }
        
        this.$emit('updateUserInfo', this.localUserInfo);
        this.$emit('saveUserInfo');
      }
    }
  };
  </script>
  
  <style scoped>
  .general-info {
    padding: 24px;
    max-width: 800px;
  }
  
  .section-title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 24px;
    color: #545051;
  }

  /* Hide title on smaller screens */
  @media (max-width: 768px) {
    .section-title {
      display: none;
    }
  }
  
  .form-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .city-state-zip {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 24px;
  margin-top: 8px;
  width: 100%; /* Ensure full width */
}

@media (max-width: 1024px) {
  .city-state-zip {
    grid-template-columns: minmax(0, 1fr); /* Use minmax to prevent overflow */
    gap: 8px;
    width: 100%;
    align-items: start; /* Align items to the start */
  }

}
  
  .actions {
    margin-top: 32px;
    display: flex;
    justify-content: flex-start;
  }
  
  .save-button {
    background-color: #545051;
    color: white;
    border: none;
    padding: 8px 24px;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: 400;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }
  
  .save-button:hover {
    background-color: #636063;
  }
  
  .save-button:disabled {
    background-color: #a8a8a8;
    cursor: not-allowed;
  }
  </style>